<template>
  <div class="my-4">
    <div class="no-print header mb-4">
      <div class="header__options">
        <p class="m-0 mr-4">Visualizar como: </p>
        <b-form-select
          v-model="ticketVisualation"
          :options="options"
          style="width: 300px;">
        </b-form-select>
      </div>
      <div>
        <b-button @click="printHere" variant="primary">Imprimir aquí</b-button>
        <b-button @click="print" variant="primary">Imprimir</b-button>
      </div>
    </div>
    <hr>
    <div class="tickets" id="section-to-print">
      <p
        v-if="loading"
        style="text-align: center; font-size: 22px;">
        Cargando...
      </p>
      <!-- :class="existPageBreak && (idx) % 2 === 0 ? '' : 'break-page'" -->
      <div v-if="qrs.length > 0 ">
        <div
          v-for="(qr, idx) in qrs"
          :key="idx"
          class="mt-4 print-block"
          :class="idx === qrs.length - 1 ? '' : 'break-page'"
          style="display: flex; justify-content: center;">
          <TicketPosFutbol
            v-if="isFootball && ticketVisualation === 'standard'"
            :item="qr"
            :detail="isDetailTicket"
            :extra="ticketInfo"
            :pulep="pulep">
          </TicketPosFutbol>
          <TicketPosPremium
            v-else-if="!isFootball && ticketVisualation === 'standard'"
            :item="qr"
            :detail="isDetailTicket"
            :extra="ticketInfo"
            :pulep="pulep">
          </TicketPosPremium>
          <TicketPrint
            v-else-if="ticketVisualation === 'impresion'"
            :item="qr"
            style="page-break-after: auto"
          />
          <TicketPos
            v-else-if="ticketVisualation === 'pos'"
            :qr="qr"
            :ticketInfo="ticketInfo"
            class="mb-4"
          />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import TicketPosPremium from '../components/Home/TicketPosPremium.vue';
import TicketPrint from '../components/Ticket/TicketDetailPrint.vue';
import TicketPos from '../components/Home/TicketPos.vue';
import TicketPosFutbol from '../components/Ticket/TicketPosFutbol'
import axios from 'axios';

const { VUE_APP_BASE_URL_JN } = process.env;

export default {
  components: { TicketPosPremium, TicketPrint, TicketPos, TicketPosFutbol },
  data() {
    return {
      ticket: null,
      qrsData: [],
      existPageBreak: false,
      isDetailTicket: null,
      baseUrlJn: VUE_APP_BASE_URL_JN,
      ticketInfo : {},
      loading: false,
      pulep: null,
      options: [
        { value: null, text: 'Selecciona una opción' },
        { value: 'standard', text: 'Estándar' },
        { value: 'impresion', text: 'Impresión' },
        // { value: 'pos', text: 'POS' }
      ],
      ticketVisualation: 'standard'
    }
  },
  computed: {
    isFootball() {
      return this.$route.query.isFootball === 'true';
    },
    transactionId() {
      return this.$route.params.tId;
    },
    qrs() {
      console.log(this.qrsData);
      return this.qrsData.map(item => {
        return this._parseUserDataObject(item, true)
      })
    },
  },
  created() {
    this.getTicketFutbol();
  },
  methods: {
    getFormatMonth(date) {
      const months = [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
      ]
      let month = new Date(date);
      let monthFormat = month.getMonth();
      return months[monthFormat];
    },
    printHere() {
      if (this.ticketVisualation === 'pos') {
        var style = document.createElement('style');
        style.innerHTML = '@page { size: 224px 410px !important; margin: 0; }';
        document.head.appendChild(style);
        window.print();
        style.remove();
        return;
      }
      window.print();
    },
    print() {
      let basePrintUrl = `${this.baseUrlJn}/ticket-detail/${this.$route.params.tId}`;
      if (this.ticketVisualation === 'standard') {
        if (this.isFootball) return window.open(`${basePrintUrl}/pos/futbol`);
        return window.open(`${basePrintUrl}/pos/ticket-pos-premium`);
      } else if (this.ticketVisualation === 'impresion') {
        return window.open(`${basePrintUrl}/ticket-print`);
      }
      if (this.ticketVisualation === 'pos') {
        var style = document.createElement('style');
        style.innerHTML = '@page { size: 224px 410px !important; margin: 0; }';
        document.head.appendChild(style);
        window.print();
        style.remove();
        return;
      }
      window.print();
    },
    _parseUserDataObject(item, futbol) {
      if (item.userData && item.userData !== '{}') {
        let name = ''
        let lastName = ''
        let doc = ''
        let docType = ''
        let position = ''
        const pFields = JSON.parse(item.userData)
        pFields.participantFields.forEach(el => {
          if (el.attributeInTicket === 6) {
            docType = el.value
          }
          if (el.attributeInTicket === 2) {
            name = el.value
          }
          if (el.attributeInTicket === 3) {
            lastName = el.value
          }
          if (el.attributeInTicket === 4) {
            doc = el.value
          }
          if (el.attributeInTicket === 1) {
            position = el.value
          }
        })

        this.$set(item, 'username', `${name} ${lastName}`)
        this.$set(item, 'document', doc)

        this.$set(item, 'docType', docType)
        if (position !== '') {
          this.$set(item, 'asiento', position)
        }
      } else {
        this.$set(item, 'username', futbol ? item.name : `${item.firstName} ${item.lastName}`)
        this.$set(item, 'document', futbol ? item.num_document : item.dniUser)
        this.$set(item, 'docType', futbol ? item.type_document : item.documentType)
      }
      return item
    },
    getTicketFutbol() {
      const body = {
        activityId: '',
        showPrinted: true,
        dniUser: this.transactionId
      };
      this.loading = true;
      axios.post('/search-ticket-by-event-and-document-user', body)
        .then(res => {
          this.qrsData = res.data.data;
          this.ticketInfo = res.data.ticket;
          // // this.emailInput = //expect a mail field
          // this.voucher = res.data.voucher;
          // // this.isTicketVisible = res.data.ticket.isPayed === 1 && res.data.ticket.isPayed === 1;
          // if(typeof this.voucher == "object" && Object.keys(this.voucher).length > 0){
          //     this.voucher.siteUrl = siteUrl
          // }
          // this.quotes = res.data.metadata.find(e=> e.key === 'feePayments');
          this.existPageBreak = res.data.metadata.find(e => e.key === 'print_acho');
          this.pulep = res.data.metadata.find(e => e.key === 'code_pulep');
          // if(res.data.ticket && this.quotes){
          this.isDetailTicket = res.data.metadata.find(e => e.key === 'showDetailTicket');
          //   if(res.data.ticket && res.data.ticket.isPayed === 1  && res.data.ticket.visibility === 0){
          //     this.isTicketVisible = true;
          //     this.isFree = res.data.ticket.paymentMethod;
          //     this.getQuotesProcess();
          //   }
          // }
          this.loading = false;
        }).catch(e => {
        console.log(e);
        this.loading = false;
        this.$bvToast.toast('Ocurrió un error, inténtalo nuevamente en unos minutos', {
          title: 'NOTA',
          solid: true,
          variant: 'danger',
          autoHideDelay: 5000
        });
      })
    },
  }
}
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.header__options {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 991px) {
  .header {
    flex-direction: column;
    gap: 1rem;
  }

  .header__options {
    flex-direction: column;
    gap: .5rem;
  }

  .tickets {
    overflow: auto;
  }
}

@media print {
  @page {
    size: initial !important;
  }
}
</style>
